module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/TemperatureMax/Kanagawa_TemperatureMax_MRI_RCP85_End.png";